import { render, staticRenderFns } from "./AuthorChapter.vue?vue&type=template&id=dd14ec08&"
import script from "./AuthorChapter.vue?vue&type=script&lang=js&"
export * from "./AuthorChapter.vue?vue&type=script&lang=js&"
import style0 from "./AuthorChapter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports